import { Divider } from 'antd';
import './index.less';
export default function DividerCenter() {
  return <Divider className="divider-center">OR</Divider>;
}
